<template lang="pug">
  app-modal(v-model="visible" :title="title" :width="800" :confirm-loading="loading" @ok="handleOk" @cancel="hide")
    app-form(:model="model" :rules="rules" ref="form" oneline :labelWidth="90")
      //- a-form-model-item(label="名称" prop="name" )
        a-input(placeholder="请输入" v-model="model.name" :max-length="30")
      //- a-form-model-item(label="行政区划" prop="district" )
        app-cascader(v-model="model.district" placeholder="请选择行政区划" 
          api="/sys/dict-datas/graph?typeCode=districtCode"
          :field="{ name: 'code', label: 'name', children: 'children' }"
        )
      a-form-model-item(label="打印备注" prop="comments" )
        div.p1
          a-checkbox-group(v-model="model.comments")
            a-row(:gutter="16")
              a-col(:sm="12" v-for="(item, index) in comments" :key="item.name" )         
                a-checkbox(:value="item.name") {{index + 1}}. {{ item.label }}
    template(slot="footer")
      a-button(@click="hide") 取消
      a-button(:loading="loading" type="primary" @click="print") 打印
    iframe(:src="pdfUrl" ref="print_pdf" style="display: none;" @load="handleOnload")
</template>

<script>
// import moment from 'moment';
export default {
  props: {
    params: Object,
    target: Object,
  },
  data() {
    return {
      visible: false,
      loading: false,

      pdfUrl: '_blank',
      title: '打印',
      model: {
        hiddenFields: [],
        comments: [
          'vendorComments',
          'takerComments',
          'keeperComments',
          'schedulerComments',
          'logisticsComments',
          'productComments',
        ],
      },
      rules: {
        name: [{ required: true, message: '必填项' }],
      },
      comments: [
        { name: 'vendorComments', label: '商家备注' },
        { name: 'takerComments', label: '接单员备注' },
        { name: 'keeperComments', label: '库管备注' },
        { name: 'schedulerComments', label: '调度备注' },
        { name: 'logisticsComments', label: '物流备注' },
        { name: 'productComments', label: '产品备注' },
      ],
    };
  },
  created() {},
  methods: {
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.model = {
        hiddenFields: [],
        comments: [
          'vendorComments',
          'takerComments',
          'keeperComments',
          'schedulerComments',
          'logisticsComments',
          'productComments',
        ],
      };
    },
    handleOk() {
      this.hide();
    },
    // 打印数据
    // moment,
    handleOnload() {
      if (this.pdfUrl !== '_blank') {
        this.$refs.print_pdf.contentWindow.print();
        // this.pdfUrl = '_blank';
        this.hide();
      }
    },
    print() {
      // 打印
      this.loading = true;
      this.$restful(
        `POST:/prj/orders/print`,
        { ...this.target, ...this.model },
        { responseType: 'blob' },
      )
        .then((res) => {
          let blob = new Blob([res], {
            type: 'application/pdf',
          });
          this.pdfUrl = URL.createObjectURL(blob);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
//
</style>
